import type { SerializeContext, SerializeOptions } from './serializeOptions';
import { serializeParagraph } from './serializeParagraph';
import { serializeTable } from './serializeTable';
import type { CastBlockContent } from '../types';

export function serializeBlock(
  block: CastBlockContent,
  options: SerializeOptions,
  context: SerializeContext = {}
): string | null {
  switch (block.type) {
    case 'paragraph':
      return serializeParagraph(block, options, context);
    case 'table':
      return serializeTable(block, options, serializeBlock, context);
  }
}
